import { motion } from "framer-motion";

import { container } from "~/components/site/layout";
import { PostCard } from "~/components/site/post-card";
import type { GetSelectedPosts } from "~/lib/post";
import { readingTime } from "~/lib/reading-time";

type Props = Readonly<{
  posts: GetSelectedPosts;
}>;

export function Posts({ posts }: Props): JSX.Element {
  return (
    <motion.div
      variants={container}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      className="grid grid-col-1 lg:grid-cols-3 blurb-gap"
    >
      {posts.map((p) => (
        <PostCard
          key={p.slug}
          post={p}
          readingTime={readingTime(p.content).text}
        />
      ))}
    </motion.div>
  );
}
